// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"263":"0cee02dd","481":"f3b5ed28","534":"e4fa1a29","576":"ce4951ac"}[chunkId] + ".js";
};